import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export type ArrowDownProps = SvgIconProps & {
  /**
   * The circular background of the arrow
   */
  backgroundColor?: string;
};

export const ArrowDown = ({
  height = 24,
  width = 24,
  color = colors.red50,
  backgroundColor = colors.red10,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 -5.24537e-07C8.8174 -6.63652e-07 5.76515 1.26428 3.51472 3.51472C1.26428 5.76515 -2.29277e-06 8.8174 -2.43189e-06 12C-2.571e-06 15.1826 1.26428 18.2348 3.51472 20.4853C5.76515 22.7357 8.8174 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 -3.85421e-07 12 -5.24537e-07Z"
      fill={getColor(backgroundColor, isColorInherited)}
      opacity={isColorInherited ? '0.1' : 1}
    />
    <path
      d="M16.7171 16.773L9.65447 15.9882C9.51402 15.9727 9.3808 15.9178 9.27016 15.8299C9.15952 15.742 9.07596 15.6247 9.02911 15.4913C8.98226 15.358 8.97402 15.2142 9.00535 15.0764C9.03667 14.9386 9.10629 14.8125 9.20617 14.7125L10.7547 13.164L7.04242 9.45166C6.90177 9.31101 6.82275 9.12024 6.82275 8.92133C6.82275 8.72242 6.90177 8.53165 7.04242 8.391L9.16374 6.26968C9.30439 6.12903 9.49516 6.05001 9.69407 6.05001C9.89298 6.05001 10.0837 6.12903 10.2244 6.26968L13.9367 9.98199L15.4853 8.43343C15.5852 8.33355 15.7114 8.26393 15.8492 8.23261C15.9869 8.20128 16.1308 8.20952 16.2641 8.25637C16.3974 8.30322 16.5148 8.38678 16.6027 8.49742C16.6906 8.60806 16.7454 8.74128 16.7609 8.88173L17.5458 15.9443C17.5581 16.0562 17.5451 16.1693 17.5079 16.2755C17.4706 16.3816 17.4099 16.478 17.3303 16.5576C17.2508 16.6372 17.1544 16.6978 17.0482 16.7351C16.9421 16.7724 16.8289 16.7854 16.7171 16.773V16.773Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
